module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/logo-下载横幅-文字.35b0c.png";